const SkeletonCard = (props) => (
    <div  aria-hidden="true" {...props}>
        <div className="card-body placeholder-glow">
        {
            props?.children ?props?.children :<>
             <h5 className="card-title">
                    <span className="placeholder col-6"></span>
                </h5>
                <p className="card-text ">
                    <span className="placeholder col-7"></span>
                </p>
            </>
        }
        </div>
    </div>
    );
export default SkeletonCard;